module.exports = __webpack_public_path__ + "img/daizy_docks.44f7eb18.jpg";